import { apiPaths } from "../../api-paths.js";
import { HttpResponse, http } from "msw";
import type { Campaigns_FindCampaign_FindCampaignQueryResponse } from "../../swagger-types/v1/index.js";
import { getCampaignsMock } from "./get-campaign-200.js";
import type { CampaignAuthenticationType } from "../../campaigns-api.js";

const campaigns: Record<string, number> = {
  Algotels_FindHotel_US: 33,
  Algotels_Skyscanner_US: 19,
  Traveluro_Wego_US: 44,
  Algotels_Tripadvisor_US: 13,
  Algotels_Trivago_US: 14,
  Holisto_OrganicTest_US: 35,
  TrivagoDeals_Google_DE: 31,
  TrivagoDeals_Google_US: 31,
  TrivagoDeals_Google_Test: 31,
  ZapTravel_Google_Test: 31,
  ZapTravel_OrganicTest_US_RDM2: 35,
};

export const campaignHandlersFactory = {
  createGetCampaign: ({ campaignName, partnerId }: { campaignName: string; partnerId: number }) =>
    http.get(`*${apiPaths.campaigns.get}`, () => {
      return HttpResponse.json(
        getCampaignsMock({
          campaignName,
          partnerId,
        }) satisfies Campaigns_FindCampaign_FindCampaignQueryResponse,
        { status: 200 },
      );
    }),
};

export const campaignHandlers = {
  getCampaign: [
    http.get(`*${apiPaths.campaigns.get}`, ({ request }) => {
      const url = new URL(request.url);

      let campaignName = url.searchParams.get("campaignName");
      const authenticated: CampaignAuthenticationType | undefined = url.searchParams.get("authenticationType") as
        | CampaignAuthenticationType
        | undefined;

      if (authenticated === "BasicAuth") {
        campaignName = "Holisto_OrganicTest_US_PR";
      }

      if (!campaignName) {
        campaignName = "Holisto_OrganicTest_US";
      }

      return HttpResponse.json(
        getCampaignsMock({
          campaignName,
          partnerId: campaigns[campaignName],
        }) satisfies Campaigns_FindCampaign_FindCampaignQueryResponse,
        { status: 200 },
      );
    }),
  ],
};
